import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { AuthShell } from "@/pages/auth/AuthShell";
import { api, apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token");
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError("");
    if (!token) { setError("Link non valido."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reimpostata. Ora puoi accedere.");
      nav("/accedi");
    } catch (err) { setError(apiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reimposta password"
      footer={<Link to="/accedi" className="text-[#2DD4BF] hover:underline">Torna all'accesso</Link>}>
      {!token ? (
        <p className="text-[#CBD5E1]" data-testid="reset-notoken">Link non valido o scaduto. Richiedi un nuovo recupero password.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          {error && <div role="alert" data-testid="reset-error" className="flex items-center gap-2 rounded-lg border border-[#EF4444]/40 bg-[#EF4444]/10 px-3 py-2 text-sm text-[#FCA5A5]"><AlertCircle className="h-4 w-4" />{error}</div>}
          <div>
            <Label htmlFor="password" className="text-[#CBD5E1]">Nuova password</Label>
            <Input id="password" data-testid="reset-password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="bg-[#0B1020] border-[#2A3655]" />
            <p className="mt-1 text-xs text-[#64748B]">Almeno 8 caratteri.</p>
          </div>
          <Button type="submit" disabled={loading} data-testid="reset-submit" className="w-full bg-[#7C3AED] hover:bg-[#6D28D9]">{loading ? "Salvataggio…" : "Reimposta password"}</Button>
        </form>
      )}
    </AuthShell>
  );
}
